import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles.css';
import HyperDX from '@hyperdx/browser';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Failed to find the root element');
}

const root = createRoot(container);

HyperDX.init({
  apiKey: process.env.REACT_APP_HYPERDX_API_KEY as string,
  service: 'outlook-services-webpage',
  consoleCapture: true,
  advancedNetworkCapture: false,
  url: process.env.REACT_APP_HYPERDX_URL as string,
  disableReplay: true,
  debug: false,
  sampling: {
    mouseInteraction: {
      MouseUp: false,
      MouseDown: false,
      Click: false,
      ContextMenu: false,
      DblClick: false,
      Focus: false,
      Blur: false,
      TouchStart: false,
      TouchEnd: false,
    },
  },
  ignoreUrls: [
    /\.css$/, // CSS files
    /\.png$/, // Images
    /\.jpg$/,
    /\.jpeg$/,
    /\.gif$/,
    /\.svg$/,
    /\.webp$/,
    /\.woff$/, // Fonts
    /\.woff2$/,
    /\.ttf$/,
    /\.eot$/,
    /\.ico$/, // Favicons
    /gstatic\.com/, // Google static
    /mapfiles/,
    /googleapis\.com.*fonts/, // Google Fonts
    /cdnjs\.cloudflare\.com/, // CDN assets
  ],
  instrumentations: {
    interactions: false,
  },
});

HyperDX.setGlobalAttributes({
  environment: process.env.REACT_APP_ENV as string,
});

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
